<template>
    <span :class="tooltipClass">
        <p v-for="(error, index) in errors" :key="index">
            {{ error }}
        </p>
    </span>
</template>

<script type="text/babel">
export default {
    props: {
        errors: {
            type: Array,
            required: true,
        },
        tooltipClass: {
            type: String,
            required: true,
        },
    },
};
</script>
